(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Star_tab_slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelectorAll('.star-products-container.swiper');
    section.forEach(section => {
        const swiper = new Swiper(section, {
            slidesPerView: section.getAttribute('data-per-row-m'),
            spaceBetween: 12,
            navigation: {
                nextEl: section.querySelector('.swiper-button-next'),
                prevEl: section.querySelector('.swiper-button-prev'),
            },
            scrollbar: {
                el: section.querySelector('.swiper-scrollbar'),
            },
            breakpoints: {
                749: {
                    slidesPerView: section.getAttribute('data-per-row'),
                    spaceBetween: 24,
                },
            },
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bkw-benefits"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
        if(window.innerWidth > 749) {
            new Swiper(".bkw-benefits-section .blocks-grid", {
                slidesPerView: 3,
                spaceBetween: 15,
                navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                },
                scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                dragSize: 25,
                }
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bkw-sticky"] && !Shopify.designMode) return;
  try {
    
  const targetSection = document.querySelector('.pp-sticky__section');
  let targetSectionPosition;
  let placeholder = document.querySelector('.sticky-placeholder');
  const anchors = document.querySelectorAll('.pp-sticky__block-container .pp-sticky__block-anchor');

  anchors.forEach((anchor) => {
    anchor.addEventListener('click', function (event) {
      event.preventDefault();
      anchors.forEach((a) => {
        a.classList.remove('active');
      });
      this.classList.add('active');
      const targetDataId = this.getAttribute('data-target');
      const targetSection = document.querySelector(`[data-id="${targetDataId}"]`);
      if (targetSection) {
        targetSection.scrollIntoView({
          behavior: 'smooth',
        });
      }
    });
  });

  function updateStickySection() {
    targetSectionPosition = placeholder.getBoundingClientRect().top + window.pageYOffset;
    handleScroll();
  }

  function handleScroll() {
    const scrollPosition = window.pageYOffset;
    const totalHeight = targetSectionPosition;
    if (scrollPosition > totalHeight) {
      placeholder.style.height = `${targetSection.offsetHeight}px`;
      targetSection.classList.add('sticky');
    } else {
      placeholder.style.height = '0';
      targetSection.classList.remove('sticky');
    }
  }

  function handleIntersection(entries) {
    entries.forEach((entry) => {
      const targetDataId = entry.target.getAttribute('data-id');
      const correspondingAnchor = document.querySelector(
        `.pp-sticky__block-container a[data-target="${targetDataId}"]`
      );

      if (entry.isIntersecting) {
        anchors.forEach((anchor) => anchor.classList.remove('active'));

        if (correspondingAnchor) {
          correspondingAnchor.classList.add('active');

          correspondingAnchor.scrollIntoView({
            behavior: 'smooth',   
            block: 'center',     
            inline: 'nearest' 
          });
        }
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersection, { threshold: 0.3 });
  const sections = document.querySelectorAll('.section');
  sections.forEach((section) => {
    observer.observe(section);
  });

  window.addEventListener('resize', updateStickySection);
  window.addEventListener('scroll', handleScroll);

  document.addEventListener('DOMContentLoaded', () => {
    placeholder = document.querySelector('.sticky-placeholder');
    updateStickySection();
    anchors.forEach((anchor) => {
      const targetDataId = anchor.getAttribute('data-target');
      const section = document.querySelectorAll(`[data-id="${targetDataId}"]`);
      section.forEach((s) => {
        observer.observe(s);
      });
    });

    
    var flickityInstance = new Flickity('[data-flickity-js]', {
      cellAlign: "left",
      contain: true,
      prevNextButtons: false,
      pageDots: false
    });
    flickityInstance.resize(); // Trigger resize after initialization making sure the layout is correct
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bkw-user-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
        if(window.innerWidth > 749) {
            new Swiper(".bkw-users-section .blocks-grid", {
                slidesPerView: 3,
                spaceBetween: 15,
                navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                },
                scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                dragSize: 25,
                }
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bkw-xmas-timeline"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    const tCText = document.querySelector(".bkw-xmas-timeline__t-c-text .open-popup");
    const tCWrapper = document.querySelector(".bkw-xmas-timeline__t-c-wrapper");
    const popupClose = document.querySelector(".bkw-xmas-timeline__t-c-wrapper .popup-close");

    if (tCText && tCWrapper) {
        tCText.addEventListener("click", function() {
            tCWrapper.style.display = "block";
            document.body.style.overflow = "hidden";
        });

        if (popupClose) {
            popupClose.addEventListener("click", function() {
                tCWrapper.style.display = "none";
                document.body.style.overflow = "";
            });
        }

        tCWrapper.addEventListener("click", function(e) {
            if (!e.target.closest(".bkw-xmas-timeline__t-c-inner")) {
                tCWrapper.style.display = "none";
                document.body.style.overflow = "";
            }
        });
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-popup"] && !Shopify.designMode) return;
  try {
    
        document.addEventListener('DOMContentLoaded', function() {
            document.querySelector('.christmas-popup-content-step-1-button').onclick = function(elem){
                document.querySelector('.christmas-popup-content-step-1').style.display = 'none';
                document.querySelector('.christmas-popup-content-step-2').style.display = 'block';
            }

            document.querySelector('.christmas-popup-content-step-2-content-button').onclick = function(elem){
                document.querySelector('.christmas-popup-content-step-2').style.display = 'none';
                document.querySelector('.christmas-popup-content-step-3').style.display = 'block';
            }

            document.querySelectorAll('.christmas-popup-content-step-3-coupon_block-copy').forEach(function(elem){
                elem.onclick = function(){
                    navigator.clipboard.writeText(elem.getAttribute('data-coupon'));
                    document.querySelector('.christmas-popup-content-step-3-coupon_blocks_wrap').classList.add('copied');
                    setTimeout(function(){
                        document.querySelector('.christmas-popup-content-step-3-coupon_blocks_wrap').classList.remove('copied');
                    }, 2000);
                }
            });
        });
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust-sticky-bar-section"] && !Shopify.designMode) return;
  try {
    
  const targetSection = document.querySelector('.cust-sticky-bar-section');
  let placeholder = document.querySelector('.cust-sticky-placeholder');
  let targetSectionPosition = document.querySelector('.cust-sticky-bar-section').offsetParent.offsetTop + document.querySelector('.cust-sticky-bar-section').offsetHeight;
  let placeholder_overlay = document.querySelector('.cust-sticky-bar-section__overlay');
  const anchors = document.querySelectorAll('.cust-sticky-bar-section .block-anchor');

  placeholder.addEventListener('click', () => {
    placeholder.classList.toggle("active");
  })
  placeholder_overlay.addEventListener('click', () => {
    placeholder.classList.toggle("active");
  })
  anchors.forEach((anchor) => {
    anchor.addEventListener('click', function (event) {
     placeholder.classList.remove("active");
      event.preventDefault();
      anchors.forEach((a) => {
        a.classList.remove('active');
      });
      this.classList.add('active');
      placeholder.querySelector(".title").innerText = this.innerText;
      const targetDataId = this.getAttribute('data-target');
      const targetSection = document.querySelector(`[data-id="${targetDataId}"]`);
        console.log(targetSection)
      if (targetSection) {
        targetSection.scrollIntoView({
          behavior: 'smooth',
        });
      }
    });
  });

  function updateStickySection() {
    targetSectionPosition = placeholder.getBoundingClientRect().top + window.pageYOffset;
    handleScroll();
  }

  function handleScroll() {
    const scrollPosition = window.pageYOffset;
    const totalHeight = targetSectionPosition;
    if (scrollPosition > totalHeight) {
      // placeholder.style.height = `${targetSection.offsetHeight}px`;
      targetSection.classList.add('sticky');
    } else {
      // placeholder.style.height = '0';
      targetSection.classList.remove('sticky');
    }
  }

  function handleIntersection(entries) {
    entries.forEach((entry) => {
      const targetDataId = entry.target.getAttribute('data-id');
      const correspondingAnchor = document.querySelector(
        `.cust-sticky-bar-section__items a[data-target="${targetDataId}"]`
      );

      if (entry.isIntersecting) {
        anchors.forEach((anchor) => anchor.classList.remove('active'));

        if (correspondingAnchor) {
          correspondingAnchor.classList.add('active');
          placeholder.querySelector(".title").innerText = correspondingAnchor.innerText;
        }
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersection, { threshold: 0.3 });
  const sections = document.querySelectorAll('.section');
  sections.forEach((section) => {
    observer.observe(section);
  });

  
  
  const observer1 = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        targetSection.classList.add('show-footer');
      } else {
        targetSection.classList.remove('show-footer');
      }
    });
  }, { threshold: 0.3 });
  const target = document.querySelector('.site-footer');
  observer1.observe(target);
  
  // window.addEventListener('resize', updateStickySection);
  window.addEventListener('scroll', handleScroll);

  document.addEventListener('DOMContentLoaded', () => {
    placeholder = document.querySelector('.cust-sticky-placeholder');
    // updateStickySection();
    anchors.forEach((anchor) => {
      const targetDataId = anchor.getAttribute('data-target');
      const section = document.querySelectorAll(`[data-id="${targetDataId}"]`);
      section.forEach((s) => {
        observer.observe(s);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_box-content"] && !Shopify.designMode) return;
  try {
    
  let swiperInstances = []; // Array to hold swiper instances

  function initCustSliderImageContent() {
    // Check if the window width is less than or equal to 749px (mobile)
    if (window.innerWidth <= 749) {
      var sliders = document.querySelectorAll('[data-js-cust-box-content-slider]');
      if (!sliders.length) return; // Exit if no sliders are found

      sliders.forEach(function (slider, index) {
        if (!swiperInstances[index]) { // Check if swiper instance already exists
          swiperInstances[index] = new Swiper(slider, {
            spaceBetween: 0,
            slidesPerView: 'auto',
            loop: false,
          });
        }
      });
    } else {
      // Destroy swiper instances on desktop
      swiperInstances.forEach(function (swiper) {
        if (swiper) {
          swiper.destroy(true, true); // Destroy the swiper instance
        }
      });
      swiperInstances = []; // Clear the array
    }
  }

  function initScrollToSection() {
    var scrollPosEnd = 0;
    document.querySelectorAll('.cust-box-content__button').forEach(function(element){
      var section_id = element.getAttribute('href');

      // Only add click event if href starts with "#"
      if (section_id.startsWith("#")) {
        element.onclick = function(e){
          e.preventDefault();
          var sectionElem = document.querySelector(section_id);
          if(sectionElem) {
            var scrollDiv;
            scrollDiv = sectionElem.offsetTop;

            scrollPosEnd = scrollDiv - 100;
            window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
          }
        };
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    initCustSliderImageContent();
    initScrollToSection();

    // Add event listener for window resize
    window.addEventListener("resize", function() {
      // Re-initialize the slider on resize
      initCustSliderImageContent();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_faq-with-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('[data-item]');
    items.forEach(item => {
      item.addEventListener('click', function() {
        this.classList.toggle('active');
        items.forEach(otherItem => {
          if (otherItem !== this) {
            otherItem.classList.remove('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m10-ecocredits-users-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    new Swiper(".ecocredits-users-section__blocks", {
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 24,
          }
        }
    });

    if(document.querySelector(".ecocredits-users-section__t-c-text .open-popup")){
      document.querySelector('.ecocredits-users-section__t-c-text .open-popup').addEventListener("click", function(){
        document.querySelector(".ecocredits-users-section__t-c-wrapper").style.display = "block";
      });

      document.querySelector(".ecocredits-users-section__t-c-wrapper").addEventListener("click", function(e){
        if(e.target.closest(".popup-close") || !e.target.closest(".ecocredits-users-section__t-c-inner")){
          document.querySelector(".ecocredits-users-section__t-c-wrapper").style.display = "none";
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m11-bf-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    if(document.querySelectorAll('.m11-bf-banner-calendar-btn').length > 0){
      document.querySelectorAll('.m11-bf-banner-calendar-btn a').forEach(function(elem){
        elem.addEventListener('click', function(){
          elem.closest('.m11-bf-banner-calendar-btn').querySelector('.add-to-calendar-btn').click();
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m11-bf-grid-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        const btn = document.querySelector('.m11-bf-grid__btn');
        const wrapper = document.querySelector('.m11-bf-grid__popup');
        const closeIcon = document.querySelector('.m11-bf-grid__popup .close-icon');
        btn.addEventListener('click', function(){
            wrapper.style.display = 'block';
        });
        closeIcon.addEventListener('click', function(){
            wrapper.style.display = 'none';
        });
        window.addEventListener('click', function(e){
            if(e.target === wrapper && e.target != document.querySelector('.m9-icon-with-popup-inner')){
                wrapper.style.display = 'none';
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m11-product-slider-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const section = document.querySelectorAll('.m11-product-slider-section .swiper');
        section.forEach(section => {
            const swiper = new Swiper(section, {
                slidesPerView: 'auto',
                spaceBetween: 12,
                navigation: {
                    nextEl: section.querySelector('.swiper-button-next'),
                    prevEl: section.querySelector('.swiper-button-prev'),
                },
                scrollbar: {
                    el: section.querySelector('.swiper-scrollbar'),
                },
                breakpoints: {
                    749: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                },
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m11-star-title"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        if(document.querySelectorAll('.m11-star-title-link').length > 0){
            document.querySelectorAll('.m11-star-title-link').forEach(function(link){
              const popupId = link.getAttribute('data-popup-id');
              const wrapper = document.querySelector(`.${popupId}`);
              const closeIcon = document.querySelector(`.${popupId} .popup-close-button`);
              link.addEventListener('click', function(e){
                  e.preventDefault();
                  document.querySelector(`.${popupId}`).style.display = 'block';
              });
              closeIcon.addEventListener('click', function(){
                  wrapper.style.display = 'none';
              });
              window.addEventListener('click', function(e){
                  if(e.target === wrapper && e.target != document.querySelector('.m11-title-rules-popup .popup-content')){
                      wrapper.style.display = 'none';
                  }
              });
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m11-user-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
        if(window.innerWidth > 749) {
            new Swiper(".m11-users-section .blocks-grid", {
                slidesPerView: 3,
                spaceBetween: 15,
                navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                },
                scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                dragSize: 25,
                }
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m12-custom-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    function setEqualHeights(containers) {
        if (!containers || containers.length === 0) return;
        
        containers.forEach(container => {
            container.style.height = 'auto';
        });
        
        let maxHeight = 0;
        containers.forEach(container => {
            const height = container.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        
        containers.forEach(container => {
            container.style.height = `${maxHeight}px`;
        });
    }

    function initPopupModal(sectionId) {
        const modal = document.getElementById(`popupModal-${sectionId}`);
        if (!modal) return;
        
        const overlay = modal.querySelector('.popup-overlay');
        const closeBtn = modal.querySelector('.popup-close');
        const popupTitle = modal.querySelector('.popup-title');
        const popupBody = modal.querySelector('.popup-body');
        
        let hoverTimer = null;
        const HOVER_DELAY = 300;
        
        function openModal(title, content) {
            popupTitle.innerHTML = title || '无标题';
            popupBody.innerHTML = content || '无内容';
            modal.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
        
        function closeModal() {
            if (hoverTimer) {
                clearTimeout(hoverTimer);
                hoverTimer = null;
            }
            modal.classList.remove('active');
            document.body.style.overflow = '';
        }
        
        overlay.addEventListener('click', closeModal);
        closeBtn.addEventListener('click', closeModal);
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modal.classList.contains('active')) {
                closeModal();
            }
        });
        
        document.querySelectorAll(`.section-${sectionId} .popup-icon`).forEach(icon => {
            icon.addEventListener('click', (e) => {
                e.stopPropagation();
                const title = icon.dataset.blockTitle;
                const content = icon.dataset.popupContent;
                openModal(title, content);
            });
            
            icon.addEventListener('mouseenter', (e) => {
                if (hoverTimer) clearTimeout(hoverTimer);
                
                hoverTimer = setTimeout(() => {
                    const title = icon.dataset.blockTitle;
                    const content = icon.dataset.popupContent;
                    openModal(title, content);
                }, HOVER_DELAY);
            });
            
            icon.addEventListener('mouseleave', () => {
                if (hoverTimer) {
                    clearTimeout(hoverTimer);
                    hoverTimer = null;
                }
            });
            
            modal.addEventListener('mouseenter', () => {
                if (hoverTimer) {
                    clearTimeout(hoverTimer);
                    hoverTimer = null;
                }
            });
            
            modal.addEventListener('mouseleave', () => {
                if (!modal.contains(document.activeElement)) {
                    closeModal();
                }
            });
        });
        
        document.addEventListener('click', (e) => {
            if (!modal.contains(e.target) && !e.target.closest('.popup-icon')) {
                closeModal();
            }
        });
    }

    const sections = document.querySelectorAll('.custom-block.swiper');
    sections.forEach(swiperContainer => {
        const swiper = new Swiper(swiperContainer, {
            navigation: {
                nextEl: swiperContainer.querySelector('.swiper-button-next'),
                prevEl: swiperContainer.querySelector('.swiper-button-prev'),
            },
            scrollbar: {
                el: swiperContainer.querySelector('.swiper-scrollbar'),
            },
            breakpoints: {
                0: {
                    spaceBetween: 16,
                    slidesPerView: 1.2,
                },
                768: {
                    spaceBetween: 16,
                    slidesPerView: 3,
                }
            },
            on: {
                init: function() {
                    const containers = swiperContainer.querySelectorAll('.custom-container');
                    setEqualHeights(containers);
                },
                resize: function() {
                    const containers = swiperContainer.querySelectorAll('.custom-container');
                    setEqualHeights(containers);
                }
            }
        });

        const containers = swiperContainer.querySelectorAll('.custom-container');
        setEqualHeights(containers);
        
        const sectionElement = swiperContainer.closest('.m12-custom-section');
        if (sectionElement) {
            const sectionId = sectionElement.classList[1]?.replace('section-', '') || '';
            if (sectionId) {
                initPopupModal(sectionId);
            }
        }
    });

    window.addEventListener('resize', function() {
        document.querySelectorAll('.custom-block.swiper').forEach(swiperContainer => {
            const containers = swiperContainer.querySelectorAll('.custom-container');
            setEqualHeights(containers);
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m8-timeline"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const popupButton = document.querySelector('.m8-timeline-section .bottom-line a');
      const popupButtonWrapper = document.querySelector('.popup-t-c-wrapper');
      const popupCloseButton = document.querySelector('.popup-close-button');

      popupButton.addEventListener('click', function() {
        popupButtonWrapper.style.display = 'block';
        document.body.classList.add('overflow-hidden');
      });

      popupCloseButton.addEventListener('click', function() {
        popupButtonWrapper.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
      });

      popupButtonWrapper.addEventListener('click', function(e) {
        if(!e.target.classList.contains('popup-t-c-popup-content') && !e.target.closest('.popup-t-c-popup-content')){
          popupButtonWrapper.style.display = 'none';
          document.body.classList.remove('overflow-hidden');
        }
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m9-icon-with-popup"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        const section = document.querySelector('.m9-icon-with-popup-section');
        const triggerClose = document.querySelector('.m9-icon-with-popup__trigger-close');
        const wrapper = document.querySelector('.m9-icon-with-popup-wrapper');
        const closeIcon = document.querySelector('.m9-icon-with-popup-inner .close-icon');
        section.querySelector('.m9-icon-with-popup-icon').addEventListener('click', function(){
            wrapper.style.display = 'block';
            section.style.display = 'none';
        });
        triggerClose.addEventListener('click', function(){
            section.style.display = 'none';
        });
        closeIcon.addEventListener('click', function(){
            wrapper.style.display = 'none';
            section.style.display = 'block';
        });
        window.addEventListener('click', function(e){
            if(e.target === wrapper && e.target != document.querySelector('.m9-icon-with-popup-inner')){
                wrapper.style.display = 'none';
                section.style.display = 'block';
            }
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-compare-table-alter"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        if(document.querySelector('.pdp-compare-table-block-subscribe-popup-button')){
            const popupButton = document.querySelector('.pdp-compare-table-block-subscribe-popup-button');
            const popupButtonWrapper = document.querySelector('.pdp-subscribe-popup-container');
            const popupCloseButton = document.querySelector('.pdp-subscribe-popup-close-button');

            popupButton.addEventListener('click', function() {
                popupButtonWrapper.style.display = 'block';
                document.body.classList.add('overflow-hidden');
            });

            popupCloseButton.addEventListener('click', function() {
                popupButtonWrapper.style.display = 'none';
                document.body.classList.remove('overflow-hidden');
            });

            popupButtonWrapper.addEventListener('click', function(e) {
                if(!e.target.classList.contains('pdp-subscribe-popup-content') && !e.target.closest('.pdp-subscribe-popup-content')){
                popupButtonWrapper.style.display = 'none';
                document.body.classList.remove('overflow-hidden');
                }
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-button"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const popupButton = document.querySelector('.popup-button-link');
    const popupButtonWrapper = document.querySelector('.popup-button-wrapper');
    const popupCloseButton = document.querySelector('.popup-close-button');

    popupButton.addEventListener('click', function() {
      popupButtonWrapper.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    });

    popupCloseButton.addEventListener('click', function() {
      popupButtonWrapper.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    });

    popupButtonWrapper.addEventListener('click', function(e) {
      if(!e.target.classList.contains('popup-button-popup-content') && !e.target.closest('.popup-button-popup-content')){
        popupButtonWrapper.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-page-product-slider-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelectorAll('.star-products-container.swiper');
    section.forEach(section => {
        const swiper = new Swiper(section, {
            slidesPerView: section.getAttribute('data-per-row-m'),
            spaceBetween: 12,
            navigation: {
                nextEl: section.querySelector('.swiper-button-next'),
                prevEl: section.querySelector('.swiper-button-prev'),
            },
            scrollbar: {
                el: section.querySelector('.swiper-scrollbar'),
            },
            breakpoints: {
                749: {
                    slidesPerView: section.getAttribute('data-per-row'),
                    spaceBetween: 24,
                },
            },
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-page-product-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelectorAll('.star-products-container.swiper');
    section.forEach(section => {
        const swiper = new Swiper(section, {
            slidesPerView: section.getAttribute('data-per-row-m'),
            spaceBetween: 12,
            navigation: {
                nextEl: section.querySelector('.swiper-button-next'),
                prevEl: section.querySelector('.swiper-button-prev'),
            },
            scrollbar: {
                el: section.querySelector('.swiper-scrollbar'),
            },
            breakpoints: {
                749: {
                    slidesPerView: section.getAttribute('data-per-row'),
                    spaceBetween: 24,
                },
            },
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-product-multiple"] && !Shopify.designMode) return;
  try {
    
    function addProducts(elem, type) {
      document.querySelectorAll(elem).forEach(function (elem) {
        elem.onclick = function (e) {
          e.preventDefault();

          var buttonElement = this.querySelector('.btn-text');
          var loaderElement = this.querySelector('.loader');
          var quantity = this.getAttribute('data-quantity').split(',');

          buttonElement.style.display = 'none';
          loaderElement.classList.remove('hide');

          var json = [];
          var products = elem.getAttribute('data-variant-ids');
          if(products != ''){
            var products_arr = products.split(',');
            products_arr.forEach(function(item,index){
              if(item != '')
                json.push({ 'id': item, 'quantity': quantity[index] });
            });
          }

          var formData = JSON.stringify({'items': json});

          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
            },
            body: formData,
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (json) {
              theme.Cart.prototype._onProductAdded();
            })
            .finally(() => {
                buttonElement.style.display = 'block';
                loaderElement.classList.add('hide');
            });
        };
      });
    }

    if (document.querySelectorAll('.btn--atc:not(.taxFreeButton)').length > 0) {
      addProducts('.btn--atc:not(.taxFreeButton)', '');
    }

  } catch(e) { console.error(e); }
})();
})();
